import { getCompanyById } from "@/requests/companies/company-by-id.request";
import { useQuery } from "@tanstack/react-query";

export const useCompanyById = (companyId: string) => {
  return useQuery({
    queryKey: ["companies", companyId],
    queryFn: () => getCompanyById({ companyId }),
    enabled: !!companyId,
  });
};
